export default __webpack_public_path__ + "static/media/graignes20.20fd660a.jpg";